import React, { useCallback, useEffect, useState } from "react";
import FixedAgent from "../../utils/api/FixedAgent";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Table from "../../components/table/Table";
import { useSelector } from "react-redux";
import styles from "./History.module.css";
import TableLoader from "../../components/ui/TableLoader";

function AllHistory() {
  const [allTransactions, setAllTransactions] = useState(null);
  const [filteredTransactions, setFilteredTransactions] =
    useState(allTransactions);
  const [searchInput, setSearchInput] = useState("");
  const [pageIsLoading, setPageIsLoading] = useState(false);

  const base_url = process.env.REACT_APP__BASE_URL;

  const token = useSelector((state) => state.userData.loginData.token);

  const fetchCustomers = useCallback(async () => {
    try {
      setPageIsLoading(true);
      const response = await FixedAgent.getManualOrderHistory({ token });
      setAllTransactions(response.data.data);
      setPageIsLoading(false);
    } catch (error) {
      setPageIsLoading(false);

      toast.error(error?.response?.data?.message, {
        position: "top-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      console.error("Failed to fetch customers", error);
    }
  }, [token]);

  useEffect(() => {
    const transactions = allTransactions?.data || allTransactions;
    if (searchInput === "") {
      setFilteredTransactions(transactions);
    } else {
      const filtered = transactions?.filter((customer) =>
        customer.plate_no?.toLowerCase().includes(searchInput.toLowerCase())
      );
      setFilteredTransactions(filtered);
    }
  }, [searchInput, allTransactions]);

  const downloadPolicyHandler = (plate_no) => {
    const url = `${base_url}/app/fixedagent/customer/order/ieiplc/download/${plate_no}`;
    const link = document.createElement("a");
    link.href = url;
    link.target = "_blank";
    link.rel = "noopener noreferrer";
    const linkName = `${plate_no}.pdf`;
    link.download = linkName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  useEffect(() => {
    fetchCustomers();
  }, [fetchCustomers]);

  return (
    <div>
      <ToastContainer />

      {!pageIsLoading ? (
        <div>
          <div className={styles.filter_wrapper}>
            <input
              type="text"
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
              placeholder="Search by plate number"
              className={styles.filter_input}
            />
            <button className={styles.export_button}>Export</button>
          </div>{" "}
          <Table
            tableData={filteredTransactions}
            table_type="order"
            downloadPolicyHandler={downloadPolicyHandler}
          />
        </div>
      ) : (
        <TableLoader />
      )}
    </div>
  );
}

export default AllHistory;
